import { render, staticRenderFns } from "./AnaliticsPage.vue?vue&type=template&id=db7ec132"
import script from "./AnaliticsPage.vue?vue&type=script&lang=js"
export * from "./AnaliticsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports